<template>
  <div class="rh-root rh-stack" :style="rootStyle">
    <!-- inline: флоу бронирования занимает место списка прямо в блоке виджета -->
    <BookingFrame
      v-if="state.booking && bookingFlow === 'inline'"
      :url="state.booking.url"
      :height="state.booking.height"
      inline
      @close="emit('closeBooking')"
    />

    <template v-else>
      <Filter
        v-if="showFilter"
        :initial="state.search"
        :api="api"
        :customer-cities="state.customerCities"
        :allow-any-city="allowAnyCity"
        @submit="onFilterSubmit"
      />

      <template v-if="state.status === 'loading' && !state.results.length">
        <div class="rh-status">
          <span class="rh-spinner" aria-label="Загрузка" />
        </div>
      </template>

      <template v-else-if="state.status === 'error'">
        <div class="rh-status rh-status-error">
          {{ state.error?.message || 'Произошла ошибка' }}
        </div>
      </template>

      <template v-else-if="state.status === 'empty'">
        <div class="rh-status">По вашему запросу ничего не найдено.</div>
      </template>

      <template v-else>
        <section v-if="state.results.length" class="rh-list">
          <Card
            v-for="item in state.results"
            :key="item.id"
            :item="item"
            @book="emit('book', item)"
          />
        </section>
        <Pagination
          :mode="pagination"
          :page="state.page"
          :total="state.total"
          :page-size="state.search.pageSize"
          :has-more="state.hasMore"
          :loading="state.status === 'loading_more'"
          @go="(p) => emit('page', p)"
          @more="emit('loadMore')"
        />
      </template>
    </template>

    <BookingFrame
      v-if="state.booking && bookingFlow === 'modal'"
      :url="state.booking.url"
      :height="state.booking.height"
      :inline="false"
      @close="emit('closeBooking')"
    />
  </div>
</template>

<script setup lang="ts">
import BookingFrame from './BookingFrame.vue';
import Card from './Card.vue';
import Filter from './Filter.vue';
import Pagination from './Pagination.vue';
import type { ApiClient } from '../api';
import type {
  BookingFlow,
  PaginationMode,
  WidgetAccommodation,
  WidgetState,
} from '../types';

defineProps<{
  state: WidgetState;
  api: ApiClient;
  showFilter: boolean;
  pagination: PaginationMode;
  bookingFlow: BookingFlow;
  allowAnyCity: boolean;
  /** CSS custom properties темы и числа колонок (см. widget.ts). */
  rootStyle: Record<string, string>;
}>();

const emit = defineEmits<{
  filter: [params: WidgetState['search']];
  page: [page: number];
  loadMore: [];
  book: [item: WidgetAccommodation];
  closeBooking: [];
}>();

function onFilterSubmit(params: WidgetState['search']): void {
  emit('filter', params);
}
</script>
